import { render, staticRenderFns } from "./BizAgreementinfoList.vue?vue&type=template&id=5ce81aa2&scoped=true&"
import script from "./BizAgreementinfoList.vue?vue&type=script&lang=js&"
export * from "./BizAgreementinfoList.vue?vue&type=script&lang=js&"
import style0 from "./BizAgreementinfoList.vue?vue&type=style&index=0&id=5ce81aa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce81aa2",
  null
  
)

export default component.exports